import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import FacetDataContext, {
  useFacetData
} from '~/context/common/FacetDataContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import { CommonWrapper, Label } from './FiltersMenu.styles';

export default function Features() {
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const { showInventoryCounts } = useContext(FacetDataContext);
  const facetData = useFacetData();
  const features = facetData.cvnaFeatures ?? {};

  return (
    <FilterDrawer
      testId="facet-features"
      facetContent={features}
      facetName="Features"
    >
      <div className="grid gap-4xl">
        {Object.keys(features).map(category => {
          return (
            <div key={category}>
              <Label>{category}</Label>
              <CommonWrapper>
                {features[category].map(
                  ({ count, displayName, key: feature }) => (
                    <Checkbox
                      analyticsAttributes={{ category }}
                      checked={appliedFilters.cvnaFeatures?.includes(feature)}
                      facet="cvnaFeatures"
                      filter={feature}
                      id={`features-${displayName}`}
                      key={feature}
                      label={
                        showInventoryCounts
                          ? `${displayName} (${count.toLocaleString()})`
                          : displayName
                      }
                      onChange={() =>
                        updateListFilter({
                          filterKey: 'cvnaFeatures',
                          value: feature
                        })
                      }
                    />
                  )
                )}
              </CommonWrapper>
            </div>
          );
        })}
      </div>
    </FilterDrawer>
  );
}
